import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { ChevronDown, Search, Menu, X } from 'lucide-react';

const MainNavigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isActivitiesOpen, setIsActivitiesOpen] = useState(false);

  return (
    <nav className="w-full bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img 
                src="/logo.png" 
                alt="Nueva Consciencia Logo" 
                className="h-12"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:block">
            <div className="ml-10 flex items-center space-x-6">
              {/* Menú desplegable */}
              <div className="relative">
                <button 
                  onClick={() => setIsActivitiesOpen(!isActivitiesOpen)}
                  className="text-[#751fab] px-3 py-2 rounded-md hover:bg-purple-50 inline-flex items-center gap-1"
                >
                  Nuestras Actividades
                  <ChevronDown className={`w-4 h-4 transform transition-transform ${isActivitiesOpen ? 'rotate-180' : ''}`} />
                </button>
                
                {isActivitiesOpen && (
                  <div className="absolute z-10 left-0 mt-2 w-72 bg-white rounded-md shadow-lg py-1">
                    <a href="/programa-gratuito" className="block px-4 py-2 text-[#751fab] hover:bg-purple-50">
                      Programa Gratuito para Buscadores
                    </a>
                    <a href="/programa-avanzado" className="block px-4 py-2 text-[#751fab] hover:bg-purple-50">
                      Programa Avanzado para Buscadores
                    </a>
                    <a href="/formaciones" className="block px-4 py-2 text-[#751fab] hover:bg-purple-50">
                      Formaciones Presenciales
                    </a>
                  </div>
                )}
              </div>

              <a href="/testimonios" className="text-[#751fab] px-3 py-2 rounded-md hover:bg-purple-50">
                Testimonios
              </a>

              <a href="/tienda" className="text-[#751fab] px-3 py-2 rounded-md hover:bg-purple-50">
                Tienda Online
              </a>
              
              {/* Search Icon */}
              <button className="text-[#751fab] p-2 rounded-md hover:bg-purple-50">
                <Search size={20} />
              </button>

              {/* CTA Button */}
              <Link to="https://enriqueciendovidas.com/" className="bg-[#751fab] text-white px-6 py-2 rounded-md hover:bg-[#ad4bed] transition-colors">
                Alumnos
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-[#751fab] p-2 rounded-md hover:bg-purple-50"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="lg:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <div className="space-y-1 pl-4">
              <div className="text-[#751fab] font-medium px-3 py-2">Nuestras Actividades:</div>
              <a href="/programa-gratuito" className="text-[#751fab] block px-3 py-2 rounded-md hover:bg-purple-50">
                Programa Gratuito para Buscadores
              </a>
              <a href="/programa-avanzado" className="text-[#751fab] block px-3 py-2 rounded-md hover:bg-purple-50">
                Programa Avanzado para Buscadores
              </a>
              <a href="/formaciones" className="text-[#751fab] block px-3 py-2 rounded-md hover:bg-purple-50">
                Formaciones Presenciales
              </a>
            </div>
            <a href="/testimonios" className="text-[#751fab] block px-3 py-2 rounded-md hover:bg-purple-50">
              Testimonios
            </a>
            <a href="/tienda" className="text-[#751fab] block px-3 py-2 rounded-md hover:bg-purple-50">
              Tienda Online
            </a>
            <Link to="https://enriqueciendovidas.com/" className="bg-[#751fab] text-white px-6 py-2 rounded-md hover:bg-[#ad4bed] transition-colors">
              Alumnos
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default MainNavigation;